var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDiscount = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M9.23 3.244a4.27 4.27 0 0 1 5.54 0c.412.35.924.563 1.463.606a4.27 4.27 0 0 1 3.917 3.917 2.57 2.57 0 0 0 .606 1.463 4.27 4.27 0 0 1 0 5.54 2.57 2.57 0 0 0-.606 1.463 4.27 4.27 0 0 1-3.917 3.917 2.57 2.57 0 0 0-1.463.606 4.27 4.27 0 0 1-5.54 0 2.57 2.57 0 0 0-1.463-.606 4.27 4.27 0 0 1-3.917-3.917 2.57 2.57 0 0 0-.606-1.463 4.27 4.27 0 0 1 0-5.54 2.57 2.57 0 0 0 .606-1.463A4.27 4.27 0 0 1 7.767 3.85a2.57 2.57 0 0 0 1.463-.606m4.438 1.294a2.57 2.57 0 0 0-3.335 0 4.27 4.27 0 0 1-2.43 1.006 2.57 2.57 0 0 0-2.358 2.358 4.27 4.27 0 0 1-1.007 2.43 2.57 2.57 0 0 0 0 3.335 4.27 4.27 0 0 1 1.007 2.43 2.57 2.57 0 0 0 2.358 2.359 4.27 4.27 0 0 1 2.43 1.006 2.57 2.57 0 0 0 3.335 0 4.27 4.27 0 0 1 2.43-1.006 2.57 2.57 0 0 0 2.358-2.358 4.27 4.27 0 0 1 1.006-2.43 2.57 2.57 0 0 0 0-3.335 4.27 4.27 0 0 1-1.006-2.43 2.57 2.57 0 0 0-2.358-2.359 4.27 4.27 0 0 1-2.43-1.006",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M8.57 15.43a.85.85 0 0 1 0-1.203l5.657-5.656a.85.85 0 0 1 1.203 1.202L9.773 15.43a.85.85 0 0 1-1.202 0",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.42 9.172a1.25 1.25 0 1 1-2.498 0 1.25 1.25 0 0 1 2.499 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.077 14.828a1.249 1.249 0 1 1-2.498 0 1.249 1.249 0 0 1 2.498 0"
}))));
export default SvgDiscount;